import { FC } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

const ListItem: FC<FlexProps> = ({ children, ...rest }) => (
  <Flex
    borderTop="1px solid"
    borderColor="secondary.300"
    p="16px 0"
    justifyContent="space-between"
    alignItems="center"
    sx={{
      _first: {
        paddingTop: 0,
        borderTop: 'none',
      },
      _last: {
        paddingBottom: 0,
      },
    }}
    {...rest}
  >
    {children}
  </Flex>
);

export default ListItem;
